import { useCallback, useMemo } from 'react';
import { ServiceRegion } from '@/entities/order';

export function useServiceRegionDisplayName(serviceRegions: ServiceRegion[]) {
  const serviceRegionMap = useMemo(() => {
    const map = new Map<string, string>();
    serviceRegions.forEach((region) => {
      if (!region.id) return;
      // codePath 우선, 없으면 name, code 순으로 fallback
      const displayName =
        region.codePath && region.codePath.length > 0
          ? region.codePath.join('-')
          : region.name || region.code;
      if (displayName) map.set(region.id, displayName);
    });
    return map;
  }, [serviceRegions]);

  const findServiceRegionDisplayNameById = useCallback(
    (serviceRegionId?: string): string => {
      return !serviceRegionId ? '' : (serviceRegionMap.get(serviceRegionId) ?? '알 수 없음');
    },
    [serviceRegionMap]
  );

  return { findServiceRegionDisplayNameById };
}
